import { statusMeta } from "@/lib/format";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  const m = statusMeta(status);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        m.cls,
        className
      )}
    >
      {m.label}
    </span>
  );
}
